import { render, staticRenderFns } from "./Quali.vue?vue&type=template&id=077d2bd4&scoped=true&"
import script from "./Quali.vue?vue&type=script&lang=js&"
export * from "./Quali.vue?vue&type=script&lang=js&"
import style0 from "./Quali.vue?vue&type=style&index=0&id=077d2bd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077d2bd4",
  null
  
)

export default component.exports